import React, { useEffect, useState } from "react";
import { Grid, Stack } from "@mui/material";
import InputField from "./forms/input/TextInput/InputField";
import FormButton from "./ui/button/FormButton";
import { apiRequest, baseURL } from "../services/auth";
import { toast } from "react-toastify";
import Spinner from "./ui/Spinner";
const VerifyPayerId = () => {
  // {{BASE_URL}}/cbs/customer_details?phoneNo={phone number}

  const [phoneNumber, setPhoneNumber] = useState("");
  const [loading, setLoading] = useState(false);

  // handle Phone Number

  const retreivePayerId = async () => {
    setLoading(true);
    const response = await fetch(
      `${baseURL}/cbs/customer_details?phoneNo=${phoneNumber}`,
      {
        method: "get",
      }
    );
    const result = await response.json();
    console.log(result);
    // setLoading(false)
    if (result?.status === "success") {
      toast.success(
        `Your PayerId is ${result?.data?.customer?.[0]?.PAYER_ID}`,
        {
          autoClose: false,
          hideProgressBar: false,
          draggable: false,
          closeOnClick: false,
        }
      );
      setLoading(false);
    } else {
      toast.error(result?.message);
      setLoading(false);
    }
  };

  return (
    <div style={{ width: window.innerWidth >= 461 ? "20rem" : "15rem" }}>
      <Grid container>
        {/*  */}
        <Grid item xs={12} md={12}>
          <InputField
            name="phoneNumber"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value.trim())}
            label="Phone Number"
            placeholder="Enter Phone Number"
            type="text"
            style={{ height: "100%" }}
          />
        </Grid>
      </Grid>
      <Stack style={{ marginTop: "10px" }}>
        {/* Register Button */}
        <FormButton
          type="submit"
          label={loading ? <Spinner width="5%" /> : "Verify"}
          width="full"
          onClick={retreivePayerId}
        />
      </Stack>
    </div>
  );
};

export default VerifyPayerId;
